import { useEffect } from 'react';

import { urlUtils } from '../../utils';

export function PaymentMethods(): JSX.Element {
  useEffect(() => {
    urlUtils.navigateToHash(`/where`);
  }, []);

  return null;
}
